import React from "react";

import UserListData from "../../../components/userlistdata/userlistdata";

const UserList = () => {
  return <UserListData />;
};

export default UserList;
